import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.zentrale-eingang';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsZentraleEingangEffects {

    ZentraleEingang$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_ZENTRALE_EINGANG),
        mergeMap((x: ac.GetZentraleEingangAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getZentraleEingang(x.veranstaltung_id).pipe(
                map((result: any) => {
                    return new ac.GetZentraleEingangErfolgreichAction(result, x.veranstaltung_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetZentraleEingangFehlerAction(error, x.veranstaltung_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.ZentraleQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.ZentraleQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.ZentraleQueryService);
        }
        return this.service;
    }
}
